import { ClientServiceProvider } from '../../../clients/services/client-service/client-service';
import { Component, ViewChild } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { FormField } from '../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { FormGroup } from '@angular/forms';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { SellionsFormsRendererComponent } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';
import { TaskService } from '../../services/task.service';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';

@IonicPage()
@Component({
  selector: 'page-task-add',
  templateUrl: 'task-add.html',
})
export class TaskAddPage {
  @ViewChild(SellionsFormsRendererComponent)
  formRenderer: SellionsFormsRendererComponent;

  form: FormField[] = [];
  value: FormGroup = new FormGroup({});

  public client: IClientModel;
  private clients: any[] = [];

  constructor(
    private clientService: ClientServiceProvider,
    private navParams: NavParams,
    private taskService: TaskService,
    private viewCtrl: ViewController,
    public config: ConfigServiceProvider,
    public textService: TextServiceProvider,
  ) {}

  ionViewWillEnter() {
    this.client = this.navParams.get('client');
    this.taskService
      .getFormDefinition()
      .then((form: FormField[]) => {
        if (this.client) {
          const clientField = form.find((field) => field.id === 'client');
          clientField.predefinedValue = this.client;
          clientField.disabled = true;
        }
        this.form = form;
      })
      .catch((error) => console.error(error));
  }

  watchClients() {
    if (!this.formRenderer.form || !this.formRenderer.form.controls['clients']) return;

    this.formRenderer.form.controls['client'].valueChanges.subscribe((client) => {
      if (typeof client === 'string') {
        this.filterClients(client.trim());
      } else {
        this.filterClients('');
      }
    });
  }

  private filterClients(searchQuery: string) {
    this.formRenderer.references['client'] = this.clients.filter((client) => this.clientService.checkAgainstClient(client, searchQuery));
  }

  onReferencesChange($event) {
    this.clients = $event.client;
  }

  assignValue(value: FormGroup) {
    this.value = value;
  }

  save() {
    this.viewCtrl.dismiss(this.value.getRawValue()).catch((err) => console.error(err));
  }

  close() {
    this.viewCtrl.dismiss().catch((err) => console.error(err));
  }
}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/task-add/task-add.ts